import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreUiModule } from '../../core-ui/core-ui.module';
import { DateComponent } from './Date.component';

@NgModule({
    imports: [CommonModule, CoreUiModule],
    declarations: [DateComponent],
    exports: [DateComponent],
    providers: []
})
export class DateModule {}
